import React from 'react';
import { Outlet } from 'react-router-dom';
import AccountantSidebar from './AccountantSidebar';

const AccountantLayout = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <AccountantSidebar />
            <main className="flex-grow">
                <Outlet />
            </main>
        </div>
    );
};

export default AccountantLayout;
